/* 
--- DEVELOPER WARNING ---
This is a generated file.
Any changes you make to this file will not be saved nor git tracked. 
*/

import selfieSegmentation_IconURL from '../RAISE_Logo.png';
import selfieSegmentation_InsetIconURL from './profile-picture.png';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export default {
	name: 
  (
    <FormattedMessage
        defaultMessage="Selfie Detector"
        description="name for the Selfie Detector extension"
        id="extension.selfieSegmentation.name"
    />
  ),
	tags: ["Made by PRG"],
	insetIconURL: selfieSegmentation_InsetIconURL,
	featured: true,
	extensionId: 'selfieSegmentation',
	iconURL: selfieSegmentation_IconURL,
}